import React from "react";
import { Link } from "react-router-dom";
import { IconArrowBack } from "@tabler/icons-react";

export default function BreadcrumbBack({ backUrl }) {
  // const breadcrumbItem = [
  //     {
  //       name: "Dashboard",
  //     },
  //     {
  //       link: "Dashboard",
  //       url: "dfsfd",
  //     },
  //   ]

  return (
    // <Breadcrumb breadcrumbItem={breadcrumbItem} />

    <div className="mb-4">
      <Link
        to={backUrl}
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100px",
          justifyContent: "space-between",
        }}
        className="btn btn-outline-primary"
      >
        <IconArrowBack className="w-[26px] h-[26px]" />
        <span style={{ fontSize: "18px" }}>უკან</span>
      </Link>
    </div>
  );
}
